(() => {
  if (window.__HF_REWARD_BAR_V1__) return;
  window.__HF_REWARD_BAR_V1__ = true;

  const EPSILON = 0.0001;
  const UPDATE_FLAG = 'data-pb-updating';
  const ROOT_SELECTOR = '.hf-cart-pb';
  const DIGIT_SELECTOR = '.hf-cart-pb[data-pb-key]';
  const SEGMENT_SELECTOR = '.hf-cart-pb__segments i';
  const SEGMENT_DURATION = 500;

  function clampScale(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    return Math.max(0, Math.min(1, parsed));
  }

  function clampProgress(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    return Math.max(0, Math.min(100, parsed));
  }

  function readCurrentProgress(root) {
    const inline = parseFloat(root.style.getPropertyValue('--pb'));
    return Number.isNaN(inline) ? null : clampProgress(inline);
  }

  function paintSegments(root, from, to, animate) {
    const fills = root.querySelectorAll(SEGMENT_SELECTOR);
    if (!fills.length) return;

    if (!animate) {
      fills.forEach((fill) => {
        fill.style.transition = 'none';
        fill.style.transitionDelay = '';
        fill.style.transitionDuration = '';
        fill.style.transitionTimingFunction = '';
      });
      void root.offsetWidth;
      return;
    }

    fills.forEach((fill) => {
      fill.style.transition = '';
    });

    const distance = Math.abs(to - from);
    if (distance < EPSILON) return;

    const taille = 100 / fills.length;
    const bas = Math.min(from, to);
    const haut = Math.max(from, to);
    const parts = [];
    let franchis = 0;

    for (let index = 0; index < fills.length; index += 1) {
      const debut = index * taille;
      const part = Math.max(0, Math.min(debut + taille, haut) - Math.max(debut, bas));
      parts.push(part);
      if (part > EPSILON) franchis += 1;
    }

    let parcouru = 0;

    for (let rang = 0; rang < fills.length; rang += 1) {
      const index = to >= from ? rang : fills.length - 1 - rang;
      const fill = fills[index];

      fill.style.transitionDelay = `${(parcouru / distance) * SEGMENT_DURATION}ms`;
      fill.style.transitionDuration = `${(parts[index] / distance) * SEGMENT_DURATION}ms`;
      fill.style.transitionTimingFunction = franchis > 1 ? 'linear' : '';
      parcouru += parts[index];
    }
  }

  function paint(root, bar, value, animate) {
    const previous = readCurrentProgress(root);

    paintSegments(root, previous == null ? value : previous, value, animate);
    root.style.setProperty('--pb', String(value));

    if (!bar) return;

    bar.style.transition = animate ? '' : 'none';
    bar.style.transform = `scaleX(${clampScale(value / 100)})`;
  }

  function applyProgress(root, progressValue, useStoredValue) {
    if (progressValue == null) return;

    const progress = clampProgress(progressValue);
    const bar = root.querySelector('.progress-bar-done');
    const storageKey = `pb:${root.dataset.pbKey || 'default'}`;

    let currentValue = readCurrentProgress(root);

    if (useStoredValue) {
      try {
        const stored = parseFloat(localStorage.getItem(storageKey));
        if (!Number.isNaN(stored)) currentValue = clampProgress(stored);
      } catch (_error) {

      }
    }

    if (currentValue == null) currentValue = progress;

    if (Math.abs(progress - currentValue) < EPSILON) {
      paint(root, bar, progress, false);
    } else {
      paint(root, bar, currentValue, false);

      requestAnimationFrame(() => {
        paint(root, bar, progress, true);
      });
    }

    try {
      localStorage.setItem(storageKey, String(progress));
    } catch (_error) {

    }
  }

  function initializeBar(root) {
    applyProgress(root, parseFloat(root.dataset.progress), true);
  }

  function initializeAllBars() {
    document.querySelectorAll(DIGIT_SELECTOR).forEach(initializeBar);
  }

  function readRewardBar(root) {
    const data = root.dataset;

    return {
      root,
      mode: data.mode || 'amount',
      levels: Math.max(1, parseInt(data.levels || '1', 10)),
      l1: parseFloat(data.l1 || '0'),
      l2: parseFloat(data.l2 || '0'),
      l3: parseFloat(data.l3 || '0'),
    };
  }

  function getRewardBars() {
    return Array.from(document.querySelectorAll(ROOT_SELECTOR))
      .map(readRewardBar)
      .filter(Boolean);
  }

  function replaceHtml(element, html) {
    if (element && element.innerHTML !== html) {
      element.innerHTML = html;
    }
  }

  function computeProgress(total, rewardBar) {
    const [mark1, mark2 = 0, mark3 = 100] =
      rewardBar.levels === 1 ? [100] : rewardBar.levels === 2 ? [50, 100] : [33.333, 66.667, 100];

    const target1 = rewardBar.l1;
    const target2 = rewardBar.l2;
    const target3 = rewardBar.l3;

    if (rewardBar.levels === 1) {
      if (target1 <= 0) return 0;
      return total <= target1 ? (total / target1) * mark1 : 100;
    }

    if (rewardBar.levels === 2) {
      if (target1 > 0 && total <= target1) {
        return (total / target1) * mark1;
      }

      if (target2 > target1 && total <= target2) {
        return mark1 + ((total - target1) * (mark2 - mark1)) / Math.max(1, target2 - target1);
      }

      return 100;
    }

    if (target1 > 0 && total <= target1) {
      return (total / target1) * mark1;
    }

    if (target2 > target1 && total <= target2) {
      return mark1 + ((total - target1) * (mark2 - mark1)) / Math.max(1, target2 - target1);
    }

    if (target3 > target2 && total <= target3) {
      return mark2 + ((total - target2) * (mark3 - mark2)) / Math.max(1, target3 - target2);
    }

    return 100;
  }

  function withUpdateFlag(root, callback) {
    try {
      root.setAttribute(UPDATE_FLAG, '1');
      callback();
    } finally {
      setTimeout(() => root.removeAttribute(UPDATE_FLAG), 0);
    }
  }

  function formatRemainingValue(amount, isAmountMode, currencySymbol) {
    if (!isAmountMode) {
      return String(Math.max(0, Math.round(amount)));
    }

    const normalized = Math.max(0, amount) / 100;
    const hasDecimals = Math.abs(normalized - Math.round(normalized)) > 0.0001;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || navigator.language || 'fr-FR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || document.documentElement.getAttribute('data-shop-currency') || 'EUR',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(normalized);
    } catch (_error) {
      const formatted = hasDecimals ? normalized.toFixed(2).replace('.', ',') : String(Math.round(normalized));
      return `${formatted}${currencySymbol}`;
    }
  }

  function updateRewardBar(rewardBar, cartState) {
    const cartValue = rewardBar.mode === 'amount' ? cartState.items_subtotal_price : cartState.item_count;
    const progress = Math.max(0, Math.min(100, computeProgress(cartValue, rewardBar))).toFixed(2);

    withUpdateFlag(rewardBar.root, () => {
      if (rewardBar.root.dataset.progress !== progress) {
        rewardBar.root.dataset.progress = progress;
      }

      const data = rewardBar.root.dataset;
      const level1 = Number(data.l1) || 0;
      const level2 = Number(data.l2) || 0;
      const level3 = Number(data.l3) || 0;
      const activeLevels = Math.max(1, parseInt(data.levels || '1', 10));
      const isAmountMode = (data.mode || 'amount') === 'amount';
      const currencySymbol = data.cur || '';
      const messageParts = [];

      if (activeLevels >= 1) {
        if (cartValue < level1) {
          messageParts.push((data.msgL1 || '').replace('#valeur', formatRemainingValue(level1 - cartValue, isAmountMode, currencySymbol)));
        } else if (activeLevels === 1 || cartValue < level2) {
          messageParts.push(data.msgL1Success || '');
        }
      }

      if (activeLevels >= 2 && cartValue >= level1) {
        if (cartValue < level2) {
          messageParts.push((data.msgL2 || '').replace('#valeur', formatRemainingValue(level2 - cartValue, isAmountMode, currencySymbol)));
        } else if (activeLevels === 2 || cartValue < level3) {
          messageParts.push(data.msgL2Success || '');
        }
      }

      if (activeLevels >= 3 && cartValue >= level2) {
        if (cartValue < level3) {
          messageParts.push((data.msgL3 || '').replace('#valeur', formatRemainingValue(level3 - cartValue, isAmountMode, currencySymbol)));
        } else {
          messageParts.push(data.msgL3Success || '');
        }
      }

      replaceHtml(
        rewardBar.root.querySelector('.shipping-message'),
        messageParts
          .filter(Boolean)
          .map((message) => `<span class="free_shipping_notice">${message}</span>`)
          .join('<br>')
      );

      const seuils = [level1, level2, level3];

      rewardBar.root.querySelectorAll('[data-pb-level]').forEach((marqueur) => {
        const seuil = seuils[Number(marqueur.dataset.pbLevel) - 1] || 0;
        marqueur.classList.toggle('is-reached', seuil > 0 && cartValue >= seuil);
      });
    });
  }

  let activeController = null;
  let activeRequest = null;
  let scheduledRefresh = 0;
  let lastRefreshAt = 0;

  function runRefresh(force = false) {
    const now = Date.now();

    if (!force && now - lastRefreshAt < 1200) {
      if (!scheduledRefresh) {
        scheduledRefresh = setTimeout(() => {
          scheduledRefresh = 0;
          runRefresh(true);
        }, 1200 - (now - lastRefreshAt));
      }
      return;
    }

    lastRefreshAt = now;
    const rewardBars = getRewardBars();
    if (!rewardBars.length) return;

    activeController?.abort();
    activeController = new AbortController();
    activeRequest = fetch('/cart.js', { signal: activeController.signal })
      .then((response) => response.json())
      .then((cartState) => {
        rewardBars.forEach((rewardBar) => updateRewardBar(rewardBar, cartState));
      })
      .catch(() => {})
      .finally(() => {
        activeRequest = null;
      });
  }

  function scheduleRefresh(force = false) {
    if (force) lastRefreshAt = 0;
    if (scheduledRefresh) return;

    scheduledRefresh = setTimeout(() => {
      scheduledRefresh = 0;
      runRefresh(force);
    }, force ? 80 : 250);
  }

  function watchProgressAttributes() {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;

            if (node.matches?.(DIGIT_SELECTOR)) {
              initializeBar(node);
            } else {
              node.querySelectorAll?.(DIGIT_SELECTOR).forEach(initializeBar);
            }
          });
          continue;
        }

        if (mutation.type === 'attributes' && mutation.attributeName === 'data-progress') {
          const target = mutation.target;
          if (target.matches?.(DIGIT_SELECTOR)) {
            applyProgress(target, parseFloat(target.dataset.progress), false);
          }
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-progress'],
    });
  }

  function watchCartDom() {
    const closestMatches = (node, selector) => node && node.closest && node.closest(selector);

    const isInternalRewardMutation = (mutation) => {
      const matchesFlaggedRoot = (node) => closestMatches(node, `${ROOT_SELECTOR}[${UPDATE_FLAG}="1"]`);

      if (matchesFlaggedRoot(mutation.target)) return true;
      if (!mutation.addedNodes) return false;

      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && matchesFlaggedRoot(node)) {
          return true;
        }
      }

      return false;
    };

    const isCountdownMutation = (mutation) => {
      const matchesCountdown = (node) => closestMatches(node, '.cdt-root');

      if (matchesCountdown(mutation.target)) return true;
      if (!mutation.addedNodes) return false;

      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && matchesCountdown(node)) {
          return true;
        }
      }

      return false;
    };

    const isCartMutation = (node) => {
      if (!(node instanceof Element)) return false;
      if (node.closest(ROOT_SELECTOR) || node.closest('.cdt-root')) return false;

      return (
        node.matches('.cart-item, [data-cart-item], form[action^="/cart"], .cart__items, .cart__totals, .cart-drawer__items, .cart-drawer__footer, [data-cart-drawer], .cart__footer') ||
        !!node.closest('#cart')
      );
    };

    ['#main-cart-items', 'cart-drawer'].forEach((selector) => {
      const root = document.querySelector(selector);
      if (!root) return;

      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (isInternalRewardMutation(mutation) || isCountdownMutation(mutation)) continue;

          let shouldRefresh = false;

          if (mutation.addedNodes) {
            for (const node of mutation.addedNodes) {
              if (isCartMutation(node)) {
                shouldRefresh = true;
                break;
              }
            }
          }

          if (!shouldRefresh && mutation.removedNodes) {
            for (const node of mutation.removedNodes) {
              if (isCartMutation(node)) {
                shouldRefresh = true;
                break;
              }
            }
          }

          if (shouldRefresh) {
            scheduleRefresh(true);
            break;
          }
        }
      }).observe(root, {
        childList: true,
        subtree: true,
      });
    });
  }

  document.addEventListener(
    'change',
    (event) => {
      if (event.target && event.target.closest && event.target.closest('#cart, cart-drawer')) {
        scheduleRefresh(false);
      }
    },
    true
  );

  [
    'ajaxCart:updated',
    'cart:updated',
    'cart:refresh',
    'shopify:section:load',
    'shopify:section:render',
    'cart:item:added',
    'cart:update',
    'cart-drawer:open',
  ].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleRefresh(true), true);
  });

  function watchCartEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cartState = event && event.cartData;

      if (!cartState || typeof cartState.item_count !== 'number' || typeof cartState.items_subtotal_price !== 'number') {
        scheduleRefresh(true);
        return;
      }

      lastRefreshAt = Date.now();
      getRewardBars().forEach((rewardBar) => updateRewardBar(rewardBar, cartState));
    });
  }

  function boot() {
    initializeAllBars();
    watchProgressAttributes();
    watchCartDom();
    watchCartEvents();
    scheduleRefresh(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
